export default __webpack_public_path__ + "static/media/welcome_wave_mobile.fe2a80c8.svg";